/**
 * Contact API Service - submits to /api/v1/contact
 */
import { BaseApiService } from '@metlas/shared';
import type { ApiResponse } from '@metlas/shared';

export type ProductLine = 'sawbridge' | 'knightsbridge';

export interface ContactFormData {
  name: string;
  email: string;
  inquiry?: string;
  /** Waitlist-only fields (metlas.ai home). Omitted by the plain contact forms. */
  company?: string;
  role?: string;
  portfolioSize?: string;
  productLines?: ProductLine[];
  /** Where the submission came from: 'waitlist', 'contact', 'careers: <role>' (max 100 chars). */
  source?: string;
}

class ContactApiService extends BaseApiService {
  constructor() {
    super('Contact');
  }

  async submit(data: ContactFormData): Promise<ApiResponse<{ message: string }>> {
    return this.post<ApiResponse<{ message: string }>>('/api/v1/contact', data);
  }
}

export const contactApiService = new ContactApiService();
